export var AudioFormat;
(function (AudioFormat) {
    AudioFormat["Dolby51"] = "Dolby51";
    AudioFormat["Dolby71"] = "Dolby71";
    AudioFormat["DolbyAtmos"] = "DolbyAtmos";
    AudioFormat["Stereo"] = "Stereo";
})(AudioFormat || (AudioFormat = {}));
export var AudioCodec;
(function (AudioCodec) {
    AudioCodec["AAC"] = "AAC";
    AudioCodec["AC3"] = "ac-3";
    AudioCodec["EC3"] = "ec-3";
    AudioCodec["MP4A2"] = "mp4a.40.2";
    AudioCodec["MP4A5"] = "mp4a.40.5";
})(AudioCodec || (AudioCodec = {}));
//# sourceMappingURL=audio-format.js.map